import { createUnleash } from 'shared/unleash/hook';

export interface UnleashToggles {
    hotjar: boolean;
    imageCarousel: boolean;
}

const { UnleashProvider, useUnleash } = createUnleash<UnleashToggles>();

export { UnleashProvider, useUnleash };
